import { render, staticRenderFns } from "./PollPoolsIndex.vue?vue&type=template&id=f0e46974"
import script from "./PollPoolsIndex.vue?vue&type=script&lang=js"
export * from "./PollPoolsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports